/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from "@sentry/angular";

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://a930ce740b75b57123233c1c34101772@sentry.qloc.de/14",
  sendDefaultPii: true
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
